module.exports = __webpack_public_path__ + "static/media/CurrentOpenings1-banner.2bcf03c1.jpg";